module.exports = __webpack_public_path__ + "img/qiwi-logo.65eb8143.svg";